<template lang="pug">
v-app
  v-dialog(v-model="dialog.editarTaxa", max-width="500", persistent, v-if="estabelecimentoSelecionado && bairro && bairro.id")
    form.Poppins(@submit.prevent="validate('bairro')", data-vv-name="bairro", style="width: 100%;")
      v-card.br-10
        v-card-title.subheading.Poppins Editar taxa para o bairro {{bairro.nome}}
        v-card
          v-card-text
              v-currency-field.inputDefault(outline, label="Valor taxa de entrega fixa", v-model="bairro.valor", placeholder="R$ 1,00", v-bind="currency_config", color="primary", :hide-details="true")
          v-card-actions
            v-spacer
            v-btn(flat, :disabled="loading", type="button", @click="dialog.editarTaxa = false;") Fechar
            v-btn.br-5(color="primary", :loading="loading", type="submit", style="color: #fff; box-shadow: none;") Salvar

  WarningSelect(v-show="!estabelecimentoSelecionado")

  v-container(grid-list-xl, fluid, v-show="estabelecimentoSelecionado")
    v-layout.Poppins(row, wrap)
      v-flex(lg12)
        v-card.pa-3.br-10.cardPadrao
          v-layout(row, wrap, align-center)
            v-flex.md6.xs12(v-if="cardapioDigital")
              label.Poppins(style="font-size: 14px; color: #111312cc;") Como a taxa de entrega é definida?
              v-layout.mt-2(row)
                span.Poppins.tipoEntregaAtual
                  i.fa.pr-2(:class="entregaPorRaio ? 'fa-map-marker' : 'fa-map-o'")
                  | {{ entregaPorRaio ? 'Geolocalização' : 'Bairros' }}
              small.mt-2(style="color: #9A9A9A; display: block;")
                | {{ entregaPorRaio ? 'A taxa é calculada pela distância entre a loja e o endereço do cliente.' : 'A taxa é definida pelo bairro do cliente.' }}
                |  Para mudar a forma de cobrança, fale com o suporte.

            v-flex.md10.xs12(v-if="!entregaPorRaio")
              v-text-field.Poppins.icon-green.inputDefault(
                label="Buscar por nome do bairro",
                color="primary",
                height="50px",
                v-model="search",
                :change="formatSearch()",
                clearable,
                outline,
                :hide-details="true"
                prepend-inner-icon="search",
                :disabled="loading"
              )
            v-spacer
            v-flex.md2.xs12
              v-menu.xs12(offset-y, :close-on-content-click="false", :close-on-click="!editing", max-width="300px" min-width="300px")
                template.xs12(v-slot:activator="{ on, attrs, }")
                  v-btn.ma-0.xs12.br-10.mt-0.botaoFiltro(v-bind="attrs", v-on="on", color="primary", depressed)
                    i.fa.fa-cog.pr-2
                    | Configurações
                v-card.pt-2.pa-2(v-if="estabelecimentoSelecionado")
                  v-list.Poppins
                      v-currency-field.md10.xs10.inputDefault(label="Pedido mínimo", v-model="config.minimo_pedidos", placeholder="R$ 1,00", v-bind="currency_config", color="primary", outline, :hide-details="true",)
                      v-divider.my-3
                      v-checkbox.my-1.pb-1.pt-0(v-model="config.ativo", label="Entrega grátis à partir de: ", :true-value="true", :false-value="false", :disabled="loading", color="primary", :hide-details="true", style="scale: .9")
                      v-currency-field.inputDefault(outline, label="Valor do pedido", v-model="config.entrega_gratis", v-bind="currency_config", color="primary", :disabled="config.ativo == 1 && $root.user.permissao_taxa_entrega && (entregaPorRaio || todosBairros.length) && !loading ? false : true", :hide-details="true")
                      template(v-if="!entregaPorRaio")
                        v-divider.my-3
                        v-checkbox.my-1.pb-1.pt-0(v-model="taxa_entrega_fixa.ativo", label="Taxa de entrega fixa", :true-value="true", :false-value="false", :disabled="loading", color="primary", :hide-details="true")
                        v-currency-field.inputDefault(outline, label="Valor taxa de entrega fixa", v-model="taxa_entrega_fixa.valor", placeholder="R$ 1,00", v-bind="currency_config", color="gray", :disabled="(taxa_entrega_fixa.ativo == 1 && $root.user.permissao_taxa_entrega && todosBairros.length) || loading ? false : true", :hide-details="true")
                      v-flex.mt-3.pl-0.pr-0.areaAddCategoria
                        v-btn.ma-0.Poppins(
                          class="btnSalvar",
                          color="primary",
                          @click="saveConfig(config)",
                          :disabled="loading"
                          depressed
                        )
                          | Salvar

    AreasEntrega(v-if="estabelecimentoSelecionado && entregaPorRaio")

    v-layout.Poppins(row, wrap, v-if="estabelecimentoSelecionado && !entregaPorRaio")
      v-flex(lg12)
        v-card.pa-3.br-10.cardPadrao
          v-layout(row, wrap)
            v-flex.md12
              v-data-table.tabelaLocalizacoes(:headers="headers", :items="list", hide-actions, :search="search", :loading="loadingBairros", color="primary", style="border-radius: 10px; background-color: blue;")
                template.d-flex(slot='items', slot-scope='props', style="display: flex; flex-direction: column; flex-grow: 1;")
                  tr(:class="{'red lighten-4': !(props.item.valor >= 0)}")
                    td.text-xs-left {{ props.item.nome }}
                    td.text-xs-left(v-if="!props.item.valor") {{ props.item.valor == 0 ? 'Entrega Grátis' : 'Não Entrega' }}
                    td.text-xs-left(v-else) {{ props.item.valor | currency }}
                    td.text-xs-right
                      v-menu(offset-y)
                        v-btn.br-5(slot="activator", color="gray", outline, small) Ações
                          v-icon arrow_drop_down
                        v-list
                          v-list-tile.Poppins(@click="editarTaxa(props.item)")
                            v-list-tile-title Editar
                          v-list-tile.Poppins(@click="removerBairro(props.item)", v-if="props.item.bairro_estabelecimento_id")
                            v-list-tile-title Desativar
  OnboardingFab(etapa="etapa_entrega")
</template>

<script>
import _ from 'lodash';
import WarningSelect from '@/components/WarningSelect';
import OnboardingFab from '@/components/OnboardingFab';
import AreasEntrega from '@/components/entrega/AreasEntrega';

const TIPOS_ENTREGA = { BAIRRO: 0, RAIO: 1 };

export default {
  $_veeValidate: {
    validator: 'new'
  },
  components:{
    WarningSelect,
    OnboardingFab,
    AreasEntrega,
  },
  data() {
    return {
      search: '',
      todosBairros: [],
      loading: false,
      loadingBairros: false,
      headers: [
        { text: 'Bairro', value: 'nome' },
        { text: 'Valor', value: 'valor' },
        { text: 'Ações', sortable: false, align: 'right' },
      ],
      taxa_entrega_fixa: {
        ativo: true,
        valor: 0,
      },
      config: {
        ativo: false,
        entrega_gratis: 0,
        minimo_pedidos: 0,
      },
      currency_config: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: "",
        precision: 2,
        masked: false,
        min: 0,
      },
      bairro: {},
      dialog: {
        editarTaxa: false,
      },
      editing: false,
    }
  },
  computed: {
    list () {
      return this.todosBairros;
    },
    estabelecimentoSelecionado(){
      return this.$root.estabelecimentoSelecionado;
    },
    // Entrega por raio só existe para loja do cardápio digital.
    cardapioDigital(){
      return this.$root.cardapioDigital;
    },
    tipoEntrega(){
      return this.estabelecimentoSelecionado ? parseInt(this.estabelecimentoSelecionado.tipo_entrega || TIPOS_ENTREGA.BAIRRO) : TIPOS_ENTREGA.BAIRRO;
    },
    entregaPorRaio(){
      return this.cardapioDigital && this.tipoEntrega === TIPOS_ENTREGA.RAIO;
    },
  },
  watch: {
    entregaPorRaio (porRaio) {
      if (!porRaio && !this.todosBairros.length) this.getBairros();
    },
  },
  created () {
    window.getApp.$on("CHANGE_ESTABELECIMENTO", this.onChangeEstabelecimento);
  },
  beforeDestroy() {
    window.getApp.$off("CHANGE_ESTABELECIMENTO", this.onChangeEstabelecimento);
  },
  mounted(){
    this.onChangeEstabelecimento()
  },
  methods: {
    onChangeEstabelecimento(){
      console.log('CHANGE_ESTABELECIMENTO BAIRROS', this.estabelecimentoSelecionado)
      if(this.estabelecimentoSelecionado){
        if(!this.entregaPorRaio) this.getBairros();
        this.config = this.estabelecimentoSelecionado.delivery ? _.cloneDeep(this.estabelecimentoSelecionado.delivery[0]) : null;
      }
    },
    formatSearch(){
        this.search = this.search.replace(',', ".")
    },
    init(){
      if(this.estabelecimentoSelecionado){
        this.getBairros();
        this.config = this.estabelecimentoSelecionado.delivery ? _.cloneDeep(this.estabelecimentoSelecionado.delivery[0]) : null;
      }
    },
    async getBairros () {
      const vm = this;
      try {
        if (!vm.estabelecimentoSelecionado) return;
        vm.loadingBairros = true;
        const response = await vm.$axios.get('/bairro', {
          params: {
            localidade_id: vm.estabelecimentoSelecionado.localidade_id,
            ativo: 1,
          },
        });
        vm.todosBairros = response.data;
        vm.getBairrosEstabelecimento(vm.estabelecimentoSelecionado);
      } catch (error) {
        let err = error.response && error.response.data ? error.response.data.error : 'Ocorreu um erro ao buscar os dados. Atualize a página!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
        vm.loadingBairros = false;
      }
    },

    salvarAlteracoes (novoBairro) {
      const vm = this;
      const index = _.findIndex(vm.todosBairros, { id: novoBairro.bairro_id });
      const bairro = _.find(vm.todosBairros, { id: novoBairro.bairro_id });
      bairro.valor = novoBairro.valor;
      bairro.bairro_estabelecimento_id = novoBairro.estabelecimento_id;
      vm.todosBairros = _.reject(vm.todosBairros, { id: novoBairro.bairro_id });
      vm.todosBairros = [...vm.todosBairros.slice(0, index), bairro, ...vm.todosBairros.slice(index)];
    },

    async getBairrosEstabelecimento (estabelecimento) {
      const vm = this;
      try {
        const response = await vm.$axios.get('/bairro-estabelecimento', {
          params:{
            estabelecimento_id: estabelecimento.id,
            localidade_id: estabelecimento.localidade_id,
          },
        });
        const todosBairros = _.cloneDeep(vm.todosBairros);
        response.data.map(bairro_estabelecimento => {
          todosBairros.map(bairro => {
            if(bairro.id == bairro_estabelecimento.bairro_id){
              bairro.bairro_estabelecimento_id = bairro_estabelecimento.id;
              bairro.valor = bairro_estabelecimento.valor;
            }
          });
        });
        vm.todosBairros = todosBairros;
        vm.checkEquals(todosBairros);
        vm.loadingBairros = false;
      } catch (error) {
        let err = error.response && error.response.data ? error.response.data.error : 'Ocorreu um erro ao buscar os dados. Atualize a página!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
        vm.loadingBairros = false;
      }
    },

    editarTaxa (bairro) {
      const vm = this;
      vm.bairro = _.cloneDeep(_.find(vm.todosBairros, { id: bairro.id }));
      vm.dialog.editarTaxa = true;
    },

    async removerBairro (bairro){
      const vm = this;
      try {
        if(_.countBy(vm.todosBairros, bairro => { return _.isNumber(bairro.bairro_estabelecimento_id); }).true == 1)
          return window.getApp.$emit('APP_ALERT', { color: 'red', text: "É necessário realizar entrega em pelo menos um bairro!" });
        if(_.countBy(vm.todosBairros, bairro => { return _.isNumber(bairro.bairro_estabelecimento_id); }).true == 1)
          return window.getApp.$emit('APP_ALERT', { color: 'red', text: "É necessário realizar entrega em pelo menos um bairro!" });

        vm.loading = true;
        await vm.$axios.delete('/bairro-estabelecimento', {
          params: {
            id: bairro.bairro_estabelecimento_id,
          },
        });
        vm.loading = false;
        delete bairro.bairro_estabelecimento_id;
        delete bairro.valor;
        const todosBairros = _.cloneDeep(vm.todosBairros);
        vm.todosBairros = todosBairros;
        vm.checkEquals(vm.todosBairros);
        vm.loading = false;
        window.getApp.$emit('APP_ALERT', { color: 'green', text: "Bairro removido com sucesso!" });
        window.getApp.$emit('APP_DIALOG_AUX');
      } catch (error) {
        vm.loading = false;
        let err = error.response && error.response.data ? error.response.data.error : 'Ocorreu erro ao salvar a taxa de entrega. Tente novamente!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
      }
    },

    async setEntregaFixa () {
      const vm = this;
      try {
        if(!vm.estabelecimentoSelecionado) return;

        vm.taxa_entrega_fixa.valor = Math.abs(vm.taxa_entrega_fixa.valor)
        if(vm.taxa_entrega_fixa.valor > 30){
          vm.taxa_entrega_fixa.ativo = false
          vm.taxa_entrega_fixa.valor = 0
          window.getApp.$emit('APP_ALERT', { color: 'red', text: "Não é possível definir taxa de entrega maior que R$30,00!" });
          return;
        }

        vm.loading = true;

        let bairros = _.filter(vm.todosBairros, bairro => _.isNumber(bairro.bairro_estabelecimento_id));
        bairros = bairros.length ? bairros : todosBairros;

        let inicializar_bairros = [];
        bairros.map(bairro => {
          inicializar_bairros.push({
            id: bairro.bairro_estabelecimento_id,
            estabelecimento_id: vm.estabelecimentoSelecionado.id,
            bairro_id: bairro.id,
            valor: vm.taxa_entrega_fixa.valor,
          });
        });

        const response = await vm.$axios.post('/bairro-estabelecimento', {
          estabelecimento_id: vm.estabelecimentoSelecionado.id,
          bairros: inicializar_bairros
        });

        vm.loading = false;
        vm.todosBairros.map(bairro => {
          if (bairro.bairro_estabelecimento_id)
            bairro.valor = response.data[0].valor;
        });
      } catch (error) {
        let err = error.response && error.response.data ? error.response.data.error : 'Ocorreu erro ao salvar a taxa de entrega. Tente novamente!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
        vm.loading = false;
      }

    },

    checkEquals (array) {
      const vm = this;
      let bairros = _.filter(array, bairro => _.isNumber(bairro.bairro_estabelecimento_id));
      if (bairros.length) {
        let equals = true;
        bairros.map(bairro1 => {
          bairros.map(bairro2 => {
            if(bairro1.valor != bairro2.valor)
              equals = false;
          });
        });
        if (equals) {
          vm.taxa_entrega_fixa.ativo = true;
          vm.taxa_entrega_fixa.valor = bairros[0].valor;
        } else{
          vm.taxa_entrega_fixa.ativo = false;
          vm.taxa_entrega_fixa.valor = 0;
        }
      }
    },

    async salvar (bairro) {
      const vm = this;
        try {
          if(!vm.estabelecimentoSelecionado) return;
          vm.loading = true;
          bairro.valor = Math.abs(bairro.valor)

          if(bairro.valor > 30){
            window.getApp.$emit('APP_ALERT', { color: 'red', text: "Não é possível definir taxa de entrega maior que R$30,00!" });
            vm.loading = false;
            vm.dialog.editarTaxa = false;
            return;
          }

          const response = await vm.$axios.put('/bairro-estabelecimento', {
            id: bairro.bairro_estabelecimento_id || null,
            valor: bairro.valor,
            estabelecimento_id: vm.estabelecimentoSelecionado.id,
            bairro_id: bairro.id
          });
          vm.loading = false;
          window.getApp.$emit('APP_ALERT', { color: 'green', text: "Bairro salvo com sucesso!" });
          vm.salvarAlteracoes(response.data)
          vm.dialog.editarTaxa = false;
          vm.taxa_entrega_fixa.ativo = false
        } catch (error) {
          vm.loading = false;
          let err = error.response && error.response.data ? error.response.data.error : 'Ocorreu erro ao salvar a taxa de entrega. Tente novamente!';
          window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
        }
    },

    async saveConfig (config) {
      const vm = this;
      try {
        if(!vm.estabelecimentoSelecionado) return;

        const delivery = _.cloneDeep(vm.estabelecimentoSelecionado.delivery[0]);

        if(!vm.entregaPorRaio && ((vm.taxa_entrega_fixa.ativo == 1 && vm.$root.user.permissao_taxa_entrega && vm.todosBairros.length) || vm.loading)){
            vm.editing = true
            const res = await vm.$confirm("Deseja realmente definir essa taxa de entrega para todos os bairros ativos?");
            if (!res) {
              config.entrega_gratis = delivery.entrega_gratis || 0
              config.minimo_pedidos = delivery.minimo_pedidos || 0
              vm.config.ativo = Boolean(delivery.entrega_gratis)
              vm.checkEquals(vm.todosBairros);
              vm.editing = false
              return
            };
          vm.setEntregaFixa();
        }

        delivery.entrega_gratis = config.ativo ? config.entrega_gratis : 0;
        delivery.minimo_pedidos = config.minimo_pedidos;
        const response = await vm.$axios.put('/delivery', delivery);
        window.getApp.$emit('APP_UPDATE_DELIVERY', response.data);
        config.minimo_pedidos = response.data.minimo_pedidos
        config.entrega_gratis = response.data.ativo ? response.data.entrega_gratis : 0;
        vm.config.ativo = Boolean(response.data.entrega_gratis)

        window.getApp.$emit('APP_ALERT', { color: 'green', text: "Configurações salvas com sucesso!" });
        vm.editing = false
      } catch (error) {
        vm.editing = false
        window.getApp.$emit('APP_ALERT', { color: 'red', text: "Erro ao salvar os dados. Tente novamente!" });
      }
    },

    async validate (scope) {
      let vm = this;
      try {
        vm.loading = true;
        const result = await vm.$validator.validateAll(scope);
        if (!result) throw "Preencha todos os campos corretamente!";
        if (scope === 'bairro') vm.salvar(vm.bairro);
        vm.$validator.reset();
      } catch (error) {
        window.getApp.$emit("APP_ALERT", { color: "red", text: error });
        vm.loading = false;
      }
    },
  }
}
</script>

<style lang="scss">
  .inputDefault .v-input__control .v-input__slot{
    background-color: #f6f6f6!important;
    border-radius: 10px;
    border: 1px solid rgba(0, 0, 0, .15)!important;
  }

  .inputDefault.v-input.v-input--is-focused .v-input__control .v-input__slot{
    border: 1px solid #1d9a5a !important;
  }
</style>
<style scoped>
  .tabelaLocalizacoes{
    background-color: red;
  }
  .tabelaLocalizacoes tbody tr:nth-of-type(2n) {
    background-color: rgba(0, 0, 0, .05);
  }
  .Poppins{
    font-family: "Poppins", "Roboto", "Helvetica";
  }
  .Captalize{
    text-transform: capitalize !important;
  }
  .conteudo {
    min-height: 100px;
    height: 100px;
  }
  .br-5{
      border-radius: 5px !important;
  }
  .br-10{
      border-radius: 10px !important;
  }
  .cardPadrao{
    box-shadow:none !important;
    background-color: transparent;
  }
  .botaoFiltro {
    color: #fff;
    height: 56px;
    width: 100%;
    font-size: 16px;
    font-weight: 700;
    text-transform: capitalize;
  }
  .tipoEntregaAtual {
    display: inline-flex;
    align-items: center;
    height: 48px;
    padding: 0 20px;
    border-radius: 10px;
    background-color: #eaeaea;
    color: #111312cc;
    font-size: 15px;
    font-weight: 600;
  }
  .botaoItemFiltro {
    color: #111312cc;
    background-color: #eaeaea !important;
    text-transform: capitalize;
  }
  .areaAddCategoria{
    justify-content: flex-start;
    display: flex;
    flex-flow:column wrap;
    align-content: stretch;
    align-items: stretch;
  }
  .btnSalvar {
    border-radius: 10px;
    color: #fff;
    min-height: 56px;
    font-size: 18px;
    font-weight: bold;
    text-transform: capitalize;
    width: 100%;
  }
  .red:hover{
    background-color: rgba(255, 17, 0, 0.473) !important;
  }
</style>
